/**
 * MKPlayer Engine Type
 */
export enum MKPlayerEngineType {
    /**
     * Bitmovin
     */
    Bitmovin = "bitmovin",

    /**
     * Unknown.
     */
    Unknown = "unknown"
}